export default "__VITE_ASSET__CB47edHO__"